"use client"

import { useSyncExternalStore } from "react"

/** Nothing to subscribe to: the answer flips once, at hydration, and never again. */
const subscribe = () => () => {}
const getClientSnapshot = () => true
const getServerSnapshot = () => false

/**
 * `false` on the server and during hydration, `true` from the first client
 * commit onward.
 *
 * For rendering anything that only the browser can know — whether someone is
 * signed in, what the OS motion preference is — where the server still has to
 * emit *something* and the two passes must agree or React discards the subtree.
 *
 * `useSyncExternalStore` rather than `useState` + `useEffect(setMounted)`: it
 * expresses the same thing without a cascading render, and it is what React
 * documents for exactly this server-snapshot/client-snapshot split.
 */
export function useIsMounted(): boolean {
    return useSyncExternalStore(subscribe, getClientSnapshot, getServerSnapshot)
}
